var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid--center ru:end-of-life__empty"},[_c('div',{staticClass:"cell__12/12 cell__8/12--md cell__6/12--lg"},[_c('RuImage',{attrs:{"src":require('~/assets/svg/end-of-life__safe.svg'),"width":160,"height":120}}),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.$t('components.endOfLifeEmptyCategory.message'))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }